module.exports = __webpack_public_path__ + "media/images/registration-bg.old-5c91c6bd067361ae09229a1f1c66fcd0.jpg";